import {
  createEntityAdapter,
  createSlice,
  PayloadAction
} from '@reduxjs/toolkit'
import { normalize } from 'normalizr'

import {
  IFilterProfile,
  IFilterProfileLite,
  IContinuousRoute,
  INetwork,
  INetworkNormalized
} from '$/types'
import {
  filterProfileSchema,
  IFilterProfileNormalizedEntities
} from 'app/entities/schema/filterProfileSchema'
import { networkSchema } from 'app/entities/schema/networkSchema'
import {
  setFilteredNetworkListSync,
  setStagingProfileFulfilledSync
} from 'app/layout/Navbar/Filters/globalFilterSlice'
import { setFilterProfileListSync } from './filterProfilesSlice'

export const linesAdapter = createEntityAdapter<IContinuousRoute, string>({
  selectId: (line) => line.id.toString()
})

const linesSlice = createSlice({
  name: 'lines',
  initialState: linesAdapter.getInitialState(),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setFilteredNetworkListSync,
      (state, action: PayloadAction<INetwork[] | undefined>) => {
        const normalized = normalize<INetwork[], INetworkNormalized>(
          action.payload,
          [networkSchema]
        )

        if (normalized.entities.continuousRoutes != null) {
          // We are upserting here unlike in network slice because lines do not
          // have *-to-many relational data, so it should be safe to do this.
          linesAdapter.upsertMany(state, normalized.entities.continuousRoutes)
        }
      }
    )

    builder.addCase(
      setFilterProfileListSync,
      (state, action: PayloadAction<IFilterProfileLite[]>) => {
        const normalized = normalize<
          IFilterProfile[],
          IFilterProfileNormalizedEntities
        >(action.payload, [filterProfileSchema])

        if (normalized.entities.continuousRoutes != null) {
          linesAdapter.upsertMany(state, normalized.entities.continuousRoutes)
        }
      }
    )

    builder.addCase(
      setStagingProfileFulfilledSync,
      (state, action: PayloadAction<IFilterProfile | undefined>) => {
        const normalized = normalize<
          IFilterProfile,
          IFilterProfileNormalizedEntities
        >(action.payload, filterProfileSchema)

        if (normalized.entities.continuousRoutes != null) {
          linesAdapter.upsertMany(state, normalized.entities.continuousRoutes)
        }
      }
    )
  }
})

export default linesSlice.reducer
